<template>
  <div>
    <a-modal v-model="visible" width="360px" :footer="false" @cancel="close('cancel')">
      <div class="qr-code-content">
        <vue-qr :logo-src="require(`@/assets/logo.png`)" :text="content.download_url" :size="240" :logo-scale="0.3" :logo-margin="8" :correct-level="3" :margin="0" />
        <div style="font-size: 28px; margin-top: 30px">
          <a-icon :type="content.platform === 'iOS' ? 'apple' : 'android'" theme="filled" class="platform" />
          {{ content.app_name }}
        </div>
        <div style="font-size: 14px; margin: 10px; color: #a9b1b3">版本: V{{ content.build_version }}<a-divider type="vertical" />类型: {{ content.category }}</div>
        <div style="font-size: 14px; margin: 10px; color: #a9b1b3">更新于: {{ content.created_time }}</div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import VueQr from 'vue-qr';
export default {
  name: 'UserModal',
  components: { VueQr },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      userForm: {
        nickname: null,
        telephone: null,
        email: null
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('close');
    }
  }
};
</script>
<style lang="less" scoped>
.qr-code-content {
  text-align: center;
  margin-top: 36px;
}
</style>
